import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const ProfileAdd = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99984 1.66667C7.8165 1.66667 6.0415 3.44167 6.0415 5.625C6.0415 7.76667 7.7165 9.5 9.89984 9.575C9.9665 9.56667 10.0332 9.56667 10.0832 9.575C10.0998 9.575 10.1082 9.575 10.1248 9.575C10.1332 9.575 10.1332 9.575 10.1415 9.575C12.2748 9.5 13.9498 7.76667 13.9582 5.625C13.9582 3.44167 12.1832 1.66667 9.99984 1.66667Z"
          fill={color}
        />
        <path
          d="M14.2333 11.7917C11.9083 10.2417 8.11663 10.2417 5.77497 11.7917C4.71663 12.5 4.1333 13.4583 4.1333 14.4833C4.1333 15.5083 4.71663 16.4583 5.76663 17.1583C6.9333 17.9417 8.46663 18.3333 9.99997 18.3333C11.5333 18.3333 13.0666 17.9417 14.2333 17.1583C15.2833 16.45 15.8666 15.5 15.8666 14.4667C15.8583 13.4417 15.2833 12.4917 14.2333 11.7917ZM11.6666 15.1083H10.625V16.15C10.625 16.4917 10.3416 16.775 9.99997 16.775C9.6583 16.775 9.37497 16.4917 9.37497 16.15V15.1083H8.3333C7.99163 15.1083 7.7083 14.825 7.7083 14.4833C7.7083 14.1417 7.99163 13.8583 8.3333 13.8583H9.37497V12.8167C9.37497 12.475 9.6583 12.1917 9.99997 12.1917C10.3416 12.1917 10.625 12.475 10.625 12.8167V13.8583H11.6666C12.0083 13.8583 12.2916 14.1417 12.2916 14.4833C12.2916 14.825 12.0083 15.1083 11.6666 15.1083Z"
          fill={color}
        />
      </svg>
    );
  },
);
export default ProfileAdd;
